// BV Color and Name Utilities

export const BV_COLORS = {
  // Support BV (chatbot)
  SUPPORT: '#4B2870',
  // Other BVs (apps)
  SEO: '#D32F2F',
  SOCIAL_MEDIA: '#1B3576',
  IMAGE_GEN: '#E67E22',
  VIDEO_GEN: '#0D5A6F',
  LEAD: '#1A562D',
};

// Map backend app names to translation keys
export const APP_NAME_TRANSLATION_KEYS = {
  'SEO': 'dashboard.training.bvutils.seoBV',
  'SocialMedia': 'dashboard.training.bvutils.socialMediaBV',
  'ImageGeneration': 'dashboard.training.bvutils.imageGenBV',
  'VideoGeneration': 'dashboard.training.bvutils.videoGenBV',
  'Lead': 'dashboard.training.bvutils.leadBV',
};

// Fallback display names (used when t function is not provided)
export const APP_NAME_MAPPING = {
  'SEO': 'SEO BV',
  'SocialMedia': 'Social Media BV',
  'ImageGeneration': 'Image Gen BV',
  'VideoGeneration': 'Video Gen BV',
  'Lead': 'Lead BV',
};

// Map app names to their colors
export const APP_COLOR_MAPPING = {
  'SEO': '#D32F2F',
  'SocialMedia': '#1B3576',
  'ImageGeneration': '#E67E22',
  'VideoGeneration': '#0D5A6F',
  'Lead': '#1A562D',
};

// Get display name for app
// If t (translation function) is provided, use translated name
// Otherwise, fall back to English name
export const getAppDisplayName = (appName, t = null) => {
  if (t && APP_NAME_TRANSLATION_KEYS[appName]) {
    const translated = t(APP_NAME_TRANSLATION_KEYS[appName]);
    if (translated) return translated;
  }
  return APP_NAME_MAPPING[appName] || appName;
};

// Get color for app
export const getAppColor = (appName) => {
  return APP_COLOR_MAPPING[appName] || '#EC4799'; // fallback color
};

// Get badge class for app
export const getAppBadgeClass = (appName) => {
  const mapping = {
    'SEO': 'assignment-badge-seo',
    'SocialMedia': 'assignment-badge-social-media',
    'ImageGeneration': 'assignment-badge-image-gen',
    'VideoGeneration': 'assignment-badge-video-gen',
    'Lead': 'assignment-badge-lead',
  };
  return mapping[appName] || 'assignment-badge-app';
};
